import { css } from '@emotion/react'

import { Sizes, Fonts } from '@thebeansgroup/sb_ui/style_helpers'
import Colours from '@thebeansgroup/ui_style_helpers/colours'
import { baby } from '@thebeansgroup/ui_style_helpers/emotion_media_queries'

export const ssoText = css`
  font-family: ${Fonts('gibson')},
  font-size: ${Sizes(0)},
  color: ${Colours('liquorice', '400')},
  margin-top: ${Sizes(4)},
  margin-bottom: ${Sizes(0)}

  ${baby} {
    margin-top: ${Sizes(0)}
  }
`
